let moment = require('moment');
let _ = require('lodash');

module.exports = function (context, options) {
    const format = options.hash.format || 'L';
    if (!context) {
        context = new Date();
    } else if (!_.isDate(context)) {
        context = moment(context, 'YYYY/MM/DD').toDate();
    }
    return moment(context).format(format);
};



// WEBPACK FOOTER //
// ./src/scripts/core/templates/templates/moment.js